/* eslint-disable no-unused-vars */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IPrice, IResponseRequests, IResquestState } from "../types/request";

const initialState: IResquestState = {
  requests: [],
  request: null,
  limit: 20,
  offset: 0,
  total: 0,
  prices: [],
  loading: false,
  loadingId: null,
};

export const request = createSlice({
  name: "request",
  initialState,
  reducers: {
    setServiceRequests: (state, action: PayloadAction<IResponseRequests>) => {
      state.requests = action.payload.data;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    },
    setServiceRequest: (state, action) => {
      state.request = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },

    createRequestPrice: (state, action: PayloadAction<IPrice>) => {
      state.prices = [action.payload, ...state.prices];
      if (state.request) {
        state.request.price = [action.payload, ...(state.request.price || [])];
      }
    },
    updateRequestPrice: (state, action: PayloadAction<IPrice>) => {
      state.prices = state.prices.map((rprice) =>
        rprice.id === action.payload.id ? action.payload : rprice,
      );
      if (state.request) {
        state.request.price = (state.request.price || []).map((rprice) =>
          rprice.id === action.payload.id ? action.payload : rprice,
        );
      }
    },
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setServiceRequestLoading: (state) => {
      state.loading = true;
    },
    setUpdate: (state) => {
      state.update = !state.update;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLoading,
  setServiceRequest,
  setServiceRequestLoading,
  setUpdate,
  setTotal,
  setServiceRequests,
  createRequestPrice,
  updateRequestPrice,
} = request.actions;

export default request.reducer;
